/**
 * Supported languages — shared config for frontend.
 *
 * `monacoId` is what Monaco Editor expects for syntax highlighting.
 * `label` is what appears in the UI dropdown.
 * `template` provides starter code for each language.
 */
const LANGUAGES = [
    {
        key: 'javascript',
        label: 'JavaScript',
        monacoId: 'javascript',
        icon: 'JS',
        template: 'console.log("Hello, World!");',
    },
    {
        key: 'typescript',
        label: 'TypeScript',
        monacoId: 'typescript',
        icon: 'TS',
        template: 'const greeting: string = "Hello, World!";\nconsole.log(greeting);',
    },
    {
        key: 'python',
        label: 'Python',
        monacoId: 'python',
        icon: 'PY',
        template: 'print("Hello, World!")',
    },
    {
        key: 'java',
        label: 'Java',
        monacoId: 'java',
        icon: 'JV',
        template: 'public class Main {\n    public static void main(String[] args) {\n        System.out.println("Hello, World!");\n    }\n}',
    },
    {
        key: 'c',
        label: 'C',
        monacoId: 'c',
        icon: 'C',
        template: '#include <stdio.h>\n\nint main() {\n    printf("Hello, World!\\n");\n    return 0;\n}',
    },
    {
        key: 'cpp',
        label: 'C++',
        monacoId: 'cpp',
        icon: 'C+',
        template: '#include <iostream>\nusing namespace std;\n\nint main() {\n    cout << "Hello, World!" << endl;\n    return 0;\n}',
    },
    {
        key: 'go',
        label: 'Go',
        monacoId: 'go',
        icon: 'GO',
        template: 'package main\n\nimport "fmt"\n\nfunc main() {\n    fmt.Println("Hello, World!")\n}',
    },
];

export default LANGUAGES;

/**
 * Get a language config by key.
 */
export const getLanguageByKey = (key) =>
    LANGUAGES.find((l) => l.key === key) || LANGUAGES[0];

/**
 * Get the Monaco language ID for a given key.
 */
export const getMonacoLanguage = (key) =>
    (LANGUAGES.find((l) => l.key === key) || LANGUAGES[0]).monacoId;
